/* eslint-disable */
// Select for Form
// modalProps -- Select 相关制定设置
// actionChange: 父级组件 回掉方法
import React from 'react'
import { Select, Form } from 'antd'
const SelectOption = Select.Option

const I2SelectForm = (props) => {
  const {
    id, // 组件 id
    modalProps, ending, // 组件 功能参数
    options, value, // 组件 数据源
    actionChange, onChange, // 请求方法
    disableOptionType, disableOption // 禁选标记 
  } = props

  const onChangeSelect = (e, option) => {
    // onChange 是 Form 回调的方法
    onChange(e, option)
    
    if (actionChange) {
      actionChange(e, option)
    }
  }
  const hanldeLabel = (value) => {
    if (ending) {
      const subValue = value.length > 12 ? `...${value.substring(value.length - 11)}` : value
      return subValue
    }
    return value
  }
  const filterOption = (inputValue, option) => {
    const formatInputValue = String(inputValue || '').toLowerCase()
    const extra = option && option.option
    const phone = extra && extra.phone != null ? String(extra.phone).toLowerCase() : ''
    if (phone && phone.indexOf(formatInputValue) > -1) return true
    const raw = option && (typeof option.children === 'string' ? option.children : option.label)
    const text = typeof raw === 'string' ? raw.toLowerCase() : ''
    if (!text) return false
    /**
     * 如果输入是英文，则从左开始 匹配
     */
    const allEng = /[a-zA-Z]$/.test(inputValue)
    if (allEng) {
      const regex = RegExp(('^' + formatInputValue))
      return regex.test(text)
    }
    return text.indexOf(formatInputValue) > -1
  }

  const handleOptionDisable = (item) => {
    if (item.selectDisabled) { return true }
    if (disableOptionType) {
      return disableOption.some(d => d[disableOptionType] === item.id)
    }
  }
  return (
      <Select
        // -- modalProps
        allowClear={true}      //  这 部分 可以根据
        showSearch={true}      //  modalProps
        placeholder={`请选择`}  //  重新定义 或者 增加
        {...modalProps}    // -------- 分割线 ---------------------
        // ---
        id={id}
        value={value}
        onChange={onChangeSelect}
        filterOption={filterOption}
        optionLabelProp='label'
        dropdownMatchSelectWidth={false}
      >
        {options.map(item => {
          return (
            <SelectOption
              key={item.id}
              value={item.id}
              option={item}
              label={hanldeLabel(item.value)}
              // 实时取值，待实现
              disabled={handleOptionDisable(item)}
            >{item.value}</SelectOption>
          )
        })}
      </Select>
  )
}
export default I2SelectForm

I2SelectForm.defaultProps = {
  modalProps: {},
  options: [],
  disableOptionType: false,
  disableOption: []
}
